// extracted by mini-css-extract-plugin
export default {"linkConquer":"LinkConquer_linkConquer__KnN1q"};